import React, { useEffect, useState } from "react";
import TopHeader from "./TopHeader";
import MainHeader from "./MainHeader";
import ScheduleModal from "../Modal/ScheduleModal";

const Header = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="sticky top-0 z-50 w-full">
        <TopHeader onScheduleClick={() => setIsModalOpen(true)} />
        <MainHeader onScheduleClick={() => setIsModalOpen(true)} />
      </div>

      <ScheduleModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default Header;
